import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'AuthenticationHandler.Error',
    defaultMessage: 'There was an error authenticating your login'
  },
  loggedIn: {
    id: 'AuthenticationHandler.LoggedIn',
    defaultMessage: 'You have logged in. Redirecting...'
  },
  loggedOut: {
    id: 'AuthenticationHandler.LoggedOut',
    defaultMessage: 'You have logged out. Redirecting...'
  },
  loggingIn: {
    id: 'AuthenticationHandler.LoggingIn',
    defaultMessage: 'Logging you in...'
  },
  loggingOut: {
    id: 'AuthenticationHandler.LoggingOut',
    defaultMessage: 'Logging you out...'
  }
})
